import React from 'react';
import ItemLocationList from './ItemLocationList';

const ItemLocations = () => {
  return <ItemLocationList />;
};

export default ItemLocations;
